module.exports = __webpack_public_path__ + "img/3friend.18b1a9f8.png";